<template lang="pug">
div(
    v-if="planQuantities"
    :size="planQuantities > 4 ? '4+': planQuantities"
  )

    .modal-covers
      .modal-covers__quotations(v-for="(quotation, key, index) in result" v-if="showModalCovers[index]")
        .modal-covers__wrapper
          .modal-covers__title(@click.prevent="showModalCovers[index] = false") Cotação
          .modal-covers__header
            .modal-covers__header__values(:class="{ 'table-quotation__col--best-seller': index === bestSeller }")
              div.plan-values
                p.plan-values__old-amount #[s {{ quotation.olderTotalValue | currency }}] #[span {{ quotation.discountPercentage }}% OFF]
                template(v-if="quotation.installmentValues")
                  div.plan-values__wrapped
                    p.plan-values__amount #[b {{ quotation.totalValue | currency }}] equivalente a
                    p.plan-values__lbl-installment {{ quotation.installmentValues.length }}x de
                    p.plan-values__value-of-installments {{ quotation.installmentValues | currency }}
                    p.plan-values__lbl-no-swear sem juros
                template(v-else)
                  p.plan-values__lbl-amount Valor Total
                  p.plan-values__amount--no-installments {{ quotation.totalValue | currency }}

            .modal-covers__header__partner(v-if="quotation.liveloPoints")
                p(v-if="insurer === 'CHUBB'").modal-covers__header__partner--text #[i.modal-covers__header__partner__partnerLogoLivelo] Nesse plano você ganha #[strong {{ quotation.liveloPoints | points }}] pontos&nbsp;Livelo*
                p(v-if="insurer === 'TOO_SEGUROS'").modal-covers__header__partner--text #[i.modal-covers__header__partner__partnerLogoLivelo] Nesse plano você ganha #[strong {{ quotation.liveloPoints | points }}] pontos&nbsp;Livelo***
          .modal-covers__plan Cobertura de: {{ quotation.packageLabel }}
          dl
            template(v-for="cover in quotation.covers")
              dt #[span.coverLabel {{ cover.label }}] #[span.coverValue {{ cover.value }}]

    .table-quotation(:class="{ 'table-quotation--partnerBB': $partnerBB }")
      .table-quotation__container
        .table-quotation__content(:class="{ 'table-quotation__content--partnerBB' : $partnerBB }")
          .table-quotation__row.table-quotation__row--best-seller
            span.table-quotation__col
            span.table-quotation__col(v-for="(quotation, key, id) in result" :class="{ 'table-quotation__col--best-seller': id === bestSeller }")
              template(v-if="id === bestSeller") {{ hasNational ? 'Mais Vendido' : 'Melhor Custo Benefício' }}

          .table-quotation__row.table-quotation__row--planName
            span.table-quotation__col
            span.table-quotation__col(v-for="(quotation, key, id) in result" :class="{ 'table-quotation__col--best-seller': id === bestSeller }")
              h2.table-quotation__col__text(:class="{ 'table-quotation__col__text--scroll' : scrolled }") {{ quotation.quoteDescription }}

          .table-quotation__row.table-quotation__row--medicalBenefits
            span.table-quotation__col
            span.table-quotation__col(v-for="(quotation, key, id) in result" :class="{ 'table-quotation__col--best-seller': id === bestSeller }")
              h2.table-quotation__col__text(:class="{ 'table-quotation__col__text--scroll' : scrolled }") com Telemedicina

          .table-quotation__row.table-quotation__row--value
            span.table-quotation__col
            span.table-quotation__col(v-for="(quotation, key, id) in result" :class="{ 'table-quotation__col--best-seller': id === bestSeller }")
              div.plan-values
                p.plan-values__old-amount #[s {{ quotation.olderTotalValue | currency }}] #[span {{ quotation.discountPercentage }}% OFF]
                template(v-if="quotation.installmentValues")
                  div.plan-values__wrapped
                    p.plan-values__amount #[b {{ quotation.totalValue | currency }}] equivalente a
                    p.plan-values__lbl-installment {{ quotation.installmentValues.length }}x de
                    p.plan-values__value-of-installments {{ quotation.installmentValues | currency }}
                    p.plan-values__lbl-no-swear sem juros
                template(v-else)
                  p.plan-values__lbl-amount Valor Total
                  p.plan-values__amount--no-installments {{ quotation.totalValue | currency }}
              div.resume
                div.resume__card(v-for="resume in resumeLabels")
                  img.resume__card-icon(src="~@/assets/icons/icon-check.svg")
                  p.resume__card-text {{resume}}
                div.resume__card(v-if="quotation.includeChip" @click="$emit('openModal', 'ChipModal')")
                  img.resume__card-icon(src="~@/assets/icons/icon-check.svg")
                  p.resume__card-text 1 Chip internacional eSIM #[span.resume__card-tooltip ?]

          .table-quotation__row.table-quotation__row--partner
            span.table-quotation__col
            span.table-quotation__col(v-for="(quotation, key, id) in result" v-if="quotation.totalValue" :class="{'table-quotation__col--best-seller': id === bestSeller}")
              span.table-quotation__col__partner.table-quotation__col__partner--partnerLivelo(v-if="quotation.liveloPoints")
                span(v-if="insurer === 'CHUBB'").table-quotation__col__partner__text #[i.table-quotation__col__partner__partnerLogoLivelo] Nesse plano você ganha #[strong {{ quotation.liveloPoints | points }}] pontos&nbsp;Livelo*
                span(v-if="insurer === 'TOO_SEGUROS'").table-quotation__col__partner__text #[i.table-quotation__col__partner__partnerLogoLivelo] Nesse plano você ganha #[strong {{ quotation.liveloPoints | points }}] pontos&nbsp;Livelo***
              span.table-quotation__col__partner.table-quotation__col__partner--partnerDotz(v-if="quotation.dotzPoints")
                span.table-quotation__col__partner__text
                  img(src="https://ciclic.imgix.net/logos/logo_dotz.png?auto=format,compress")
                  p Nesse plano você ganha #[strong {{ quotation.dotzPoints | points }}] pontos&nbsp;Dotz*
          .table-quotation__row.table-quotation__row--cover-value
            span.table-quotation__col
            span.table-quotation__col(v-for="(quotation, key, id) in result" :class="{'table-quotation__col--best-seller': id === bestSeller}") #[b Cobertura] #[br] #[strong {{ quotation.packageLabel }}]

          .table-quotation__row.table-quotation__row--covers
            span.table-quotation__col
            span.table-quotation__col(v-for="(quotation, key, id) in result" :class="{'table-quotation__col--best-seller': id === bestSeller}")
              div
                span(v-for="(value, label) in firstsCoversByLabel").table-quotation__cover-list
                  span.table-quotation__cover-label {{ label }}:
                  span.table-quotation__cover-value {{ value[quotation.planName] }}
                span.table-quotation__cover-link(tabindex="0" @click.prevent="showModalCovers[id] = true") Ver todas as coberturas

          .table-quotation__row.table-quotation__row--button
            span.table-quotation__col Coberturas*
            span.table-quotation__col(v-for="(quotation, key, id) in result" :class="{'table-quotation__col--best-seller':  id === bestSeller}")
              button.table-quotation__button(type="button" @click.prevent="selectQuotation(key)") Selecionar

          .table-quotation__row.table-quotation__row--item(v-if="index < initListCovers" v-for="(value, label, index) in coversByLabel")
            span.table-quotation__col {{ label }}
            span.table-quotation__col(v-for="(quotation, key) in result") {{ value[quotation.planName] }}

      .table-quotation__container.table-quotation__container--listCoversCustom
        .table-quotation__row.table-quotation__row--item(v-if="index > finishListCovers" v-for="(value, label, index) in coversByLabel")
          span.table-quotation__col {{ label }}
          span.table-quotation__col(v-for="(quotation, key) in result") {{ value[quotation.planName] }}

    QuotationDisclaimers(:insurer="insurer")
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { currency, points, clubeLiveloPoints } from '@/filters'
import ModalBase from '@/components/ModalBase.vue'
import QuotationDisclaimers from '@/components/ui/QuotationDisclaimers.vue'

export default {
  data () {
    return {
      isModal: false,
      planQuantities: 0,
      showModalCovers: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false
      },
      scrolled: false,
      initListCovers: 0,
      finishListCovers: 0
    }
  },
  filters: {
    currency,
    points,
    clubeLiveloPoints
  },
  props: {
    covidCoverage: {
      type: String,
      required: true
    },
    covidCoverageLabel: {
      type: String,
      required: true
    }
  },
  components: {
    QuotationDisclaimers,
    ModalBase
  },
  created () {
    // Distribuição dinamica das coberturas, para realizar a separação na tabela.
    this.initListCovers = Object.keys(this.coversByLabel).length - 5 + 1
    this.finishListCovers = this.initListCovers - 1

    // Assim que o usuário começar a scrollar a página, dispara esse evento chamando a função handleScroll()
    window.addEventListener('scroll', this.handleScroll)

    this.planQuantities = Object.keys(this.result).length
  },
  mounted () {
    if (this.planQuantities && this.userUuid) {
      // Disparo do evento referente ao lead
      if (this.$router.currentRoute.query.destinationId !== 'BR') {
        window.dataLayer.push({
          event: 'lead-viagem-success',
          leadid: this.userUuid
        })
      }

      // DataLayer para Retargeting
      window.dataLayer.push({
        event: 'afiliattionTag',
        level: 'productPage',
        productName: this.userUuid,
        productDetail: this.destination,
        productAmount: this.$options.filters.currency(
          Object.values(this.result)[0].totalValue
        ),
        productURL: window.location.href,
        productCurrency: 'BRL'
      })
    }
    this.initialLeadAmount()
  },
  computed: {
    ...mapState('quotation', [
      'result',
      'userUuid',
      'promoCodeExpiration',
      'insurer',
      'hasNational'
    ]),
    ...mapState('travelSetup', ['lead']),
    ...mapGetters('quotation', [
      'destination',
      'coversByLabel',
      'firstsCoversByLabel',
      'totalNumberOfPassengers'
    ]),
    ...mapGetters('travelSetup', ['getLeadInfo']),
    resumeLabels () {
      return [
        `Valor para ${this.totalNumberOfPassengers} ${
          this.totalNumberOfPassengers === 1 ? 'passageiro' : 'passageiros'
        }`,
        `${this.insurer === 'TOO_SEGUROS' ? 'Telemedicina Albert Einstein' : 'Telemedicina inclusa'}`
      ]
    },
    bestSeller () {
      return this.hasNational ? 2 : 1
    }
  },
  methods: {
    ...mapActions('travelSetup', ['patchLeadAction']),
    ...mapMutations('user', ['resetListPassengers']),
    ...mapMutations('quotation', ['setQuotationUrl', 'setQuotation']),
    selectQuotation (index) {
      window.dataLayer.push({
        event: 'gaevent',
        gaEventCategory: 'Contratação',
        gaEventAction: '0.5.Cadastrar',
        gaEventLabel: `${index}`
      })

      this.$emit('appearWarning', false)
      this.$store.state.quotation.selectedQuote = index
      this.resetListPassengers()

      if (this.isExpiredPromoCode()) {
        return this.$emit('openModal', 'ExpiredPromoCodeModalContent')
      }
      this.setQuotationUrl()
      this.$router.push('/passageiros')
    },
    applyPromoCode () {
      let query = Object.assign({}, this.$route.query)

      query.promoCode = this.inputPromoCode
      this.$router.replace({ query })
    },
    clickTracking () {
      window.dataLayer.push({
        event: 'viagem-ciclic',
        gaEventAction: `${this.promoCode.value}`,
        gaEventCategory: 'validacao-promocode',
        gaEventLabel: `${this.promoCode.valid ? 'validado' : 'erro'}`
      })
    },
    addPromoCode (value) {
      this.inputPromoCode = value
      this.applyPromoCode()
    },
    isExpiredPromoCode () {
      const promoCodeExpirationLessThreeHours = new Date(
        this.promoCodeExpiration
      ).setHours(
        new Date(this.promoCodeExpiration).getHours() - 3 // server is 3 hours ahead
      )
      return promoCodeExpirationLessThreeHours < Date.parse(new Date())
    },
    initialLeadAmount () {
      this.$store.state.quotation.selectedQuote = Object.keys(this.result)[this.bestSeller]
    }
  },
  watch: {
    getLeadInfo () {
      this.patchLeadAction()
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss">
@import "~@/style/ui/variables";

div[size="2"],
div[size="4+"] {
  padding-bottom: 60px;
}

.table-quotation {
  overflow-x: auto;

  @media screen and (max-width: 400px) {
    margin-right: 16px;
  }

  @media only screen and (min-width: 1211px) {
    overflow-x: inherit;
  }

  &__container {
    width: 100%;
    max-width: 1280px;
    margin: 48px auto 32px;
    padding: 0 16px;

    @media screen and (min-width: 1211px) {
      padding: 0;
    }

    &--listCoversCustom {
      margin-top: -32px;

      @media only screen and (max-width: 1080px) {
        div[size="2"] & {
          display: none;
        }
      }

      @media only screen and (max-width: 1210px) {
        div[size="4+"] &,
        div[size="4"] &,
        div[size="3"] & {
          display: none;
        }
      }

      .table-quotation__row--item {
        &:last-child {
          border-bottom-right-radius: 12px;
          border-bottom-left-radius: 12px;

          .table-quotation__col {
            border-bottom: solid 1px rgba(189, 194, 198, 0.3);
          }

          .table-quotation__col:first-child {
            border-bottom-left-radius: 12px;
          }

          .table-quotation__col:last-child {
            border-bottom-right-radius: 12px;
          }
        }
      }
    }
  }

  &--partnerBB {
    &__title {
      margin-top: 30px;
      color: #0038a8;
      font-size: 22px;
      text-align: center;

      @media only screen and (min-width: 768px) {
        font-size: 30px;
      }
    }

    .table-quotation__row {
      &--best-seller {
        .table-quotation__col--best-seller {
          background-color: #f8d117;
          color: #0038a8;
          border-color: #f8d117;
        }
      }

      &--planName,
      &--medicalBenefits,
      &--value,
      &--partner,
      &--cover-value,
      &--covers,
      &--button {
        .table-quotation__col--best-seller {
          border-color: #f8d117;
          color: #0038a8;

          h2 {
            color: #0038a8;
          }
        }
      }

      &--button {
        .table-quotation__col:first-child {
          background-color: #f8d117;
          color: #0038a8;
        }

        .table-quotation__col--best-seller {
          .table-quotation__button {
            background-color: #f8d117;
            color: #0038a8;
            border-color: #f8d117;
          }
        }

        .table-quotation__button {
          border-color: #0038a8;
          color: #0038a8;
        }
      }
    }
  }

  &__subtitle {
    width: 100%;
    display: block;
    margin: 40px auto 16px;
    max-width: 1280px;
    text-align: left;

    @media screen and (max-width: 1320px) {
      padding-left: 32px;
      padding-right: 32px;
    }

    @media screen and (max-width: 400px) {
      padding-left: 16px;
      padding-right: 16px;
    }

    p {
      color: $color-scorpion;
      font-size: 14px;
      font-family: $rubik-font-family;
      line-height: 1.43;
    }

    &__link {
      text-decoration: underline;
      color: $color-scorpion;
      font-weight: 500;

      &:hover {
        color: #1565c0;
      }
    }
  }

  &__content {
    div[size="2"] & {
      min-width: 550px;
    }

    &--partnerBB {
      .table-quotation__row {
        &--best-seller {
          .table-quotation__col--best-seller {
            background-color: #f8d117 !important;
            color: #0038a8 !important;
            border-color: #f8d117 !important;
          }
        }

        &--value,
        &--partner,
        &--cover-value,
        &--covers,
        &--button {
          .table-quotation__col--best-seller {
            border-color: #f8d117 !important;
          }
        }

        &--button {
          .table-quotation__col:first-child {
            background-color: #f8d117 !important;
            color: #0038a8 !important;
          }

          .table-quotation__col--best-seller {
            .table-quotation__button {
              background-color: #f8d117 !important;
              color: #0038a8 !important;
              border-color: #f8d117 !important;
            }
          }

          .table-quotation__button {
            border-color: #0038a8 !important;
            color: #0038a8 !important;
          }
        }
      }
    }
  }

  &__header {
    background-color: $white;
    display: flex;
    position: relative;
  }

  &__header-item {
    width: 25%;
    display: block;
  }

  &__row {
    display: flex;
    align-items: stretch;
    width: 100%;

    @media only screen and (max-width: 1080px) {
      div[size="2"] & {
        .table-quotation__col:first-child {
          display: none;
        }
      }
    }

    div[size="2"] & {
      @media screen and (min-width: 1081px) {
        max-width: 911px;
      }
    }

    &--best-seller {
      .table-quotation__col {
        border: none !important;
        padding: 6px 24px;
        height: 30px;
        line-height: 24px;
      }

      .table-quotation__col--best-seller {
        width: 100%;
        height: 40px;
        border: 2px solid $color-purple-heart;
        background-color: $color-purple-heart;
        border-radius: 12px 12px 0 0;
        color: $white;
        font-family: $oscine-font-family;
        font-size: 18px;
        font-weight: bold;
        position: relative;
        top: 0;
        right: 0;
        text-align: center;

        div[size="4+"] &,
        div[size="4"] & {
          right: 1px;

          @media only screen and (max-width: 1210px) {
            left: 0;
          }
        }
      }
    }

    &--planName {
      height: 60px;
      position: sticky;
      top: 64px;
      z-index: 1;
      background-color: #f0f4f9;

      @media only screen and (max-width: 1080px) {
        div[size="2"] & {
          position: relative;
          top: initial;
          z-index: initial;

          .table-quotation__col:first-child {
            display: none;
          }

          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-bottom: none;
          }

          .table-quotation__col:not(.table-quotation__col--best-seller) {
            border-top-right-radius: 12px;
            border-top-left-radius: 12px;
          }
        }
      }

      @media only screen and (max-width: 1210px) {
        div[size="3"] &,
        div[size="4"] &,
        div[size="4+"] & {
          position: relative;
          top: initial;
          z-index: initial;

          .table-quotation__col:first-child {
            display: none;
          }

          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-bottom: none;
          }
          .table-quotation__col:not(.table-quotation__col--best-seller) {
            border-top-right-radius: 12px;
            border-top-left-radius: 12px;
          }
        }
      }

      .table-quotation__col:nth-child(2):not(.table-quotation__col--best-seller) {
        border-top-left-radius: 12px;
      }

      .table-quotation__col:last-child:not(.table-quotation__col--best-seller) {
        border-top-right-radius: 12px;
      }

      .table-quotation__col {
        &--best-seller {
          h2 {
            color: $color-purple-heart;
          }
        }

        &__text {
          font-size: 24px;
          font-family: $oscine-font-family;
          font-weight: bold;
          color: $color-scorpion;
          text-align: center;

          &--scroll {
            font-size: 18px;
          }
        }

        &:not(:first-child) {
          background-color: $white;
        }
      }
    }

    &--medicalBenefits {
      font-family: $oscine-font-family;
      line-height: 1.2em;
      text-align: center;
      height: 60px;
      padding: 0 0;

      @media only screen and (max-width: 1080px) {
        div[size="2"] & {
          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-bottom: none;
            border-top: none;
          }
        }
      }

      @media only screen and (max-width: 1210px) {
        div[size="3"] &,
        div[size="4"] &,
        div[size="4+"] & {
          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-bottom: none;
            border-top: none;
          }
        }
      }

      .table-quotation__col {
        padding: 0 10px;
      }

      .table-quotation__col__text {
        font-size: 16px;
      }
    }

    &--value {
      font-family: $oscine-font-family;
      font-size: 14px;
      line-height: 1.2em;
      text-align: center;

      @media only screen and (max-width: 999px) {
        font-size: 12px;
        height: auto;
      }

      @media only screen and (max-width: 1080px) {
        div[size="2"] & {
          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-bottom: none;
            border-top: none;
          }
        }
      }

      @media only screen and (max-width: 1210px) {
        div[size="3"] &,
        div[size="4"] &,
        div[size="4+"] & {
          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-bottom: none;
            border-top: none;
          }
        }
      }

      .no-wrap {
        white-space: nowrap;
      }

      strong {
        font-family: $oscine-font-family;
        font-size: 30px;
        line-height: 1.2em;
        white-space: nowrap;

        @media only screen and (min-width: 1211px) {
          display: block;
        }
      }

      .plots {
        font-size: 14px;
      }

      .table-quotation__col {
        position: relative;
      }

      .resume {
        display: flex;
        flex-direction: column;
        gap: 8px;
        &__card {
          display: flex;
          align-items: center;
          padding: 8.25px 12px 8.25px 14.25px;
          background-color: #f6f6f6;
          border-radius: 8px;
          gap: 6.25px;
          &-text {
            align-items: center;
            color: #595959;
            display: flex;
            font-weight: bold;
            font-size: 12px;
            line-height: normal;
            justify-content: space-between;
            width: 100%;
          }
          &-tooltip {
            align-items: center;
            background-color: #373739;
            border-radius: 40px;
            color: #FFFFFF;
            cursor: pointer;
            padding: 5px 9px;
          }
        }
      }
    }

    &--cover-value {
      font-size: 16px;
      background-color: #f0f4f9;
      font-family: $oscine-font-family;
      line-height: 1.2em;
      text-align: center;
      position: sticky;
      top: 124px;
      z-index: 1;

      b {
        color: $color-scorpion;
        font-family: $rubik-font-family;
        font-weight: normal;
      }

      @media only screen and (max-width: 1080px) {
        div[size="2"] & {
          position: relative;
          top: initial;
          z-index: initial;

          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-bottom: none;
            border-top: none;
          }
        }
      }

      @media only screen and (max-width: 1210px) {
        div[size="4+"] &,
        div[size="4"] &,
        div[size="3"] & {
          position: relative;
          top: initial;
          z-index: initial;

          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-bottom: none;
            border-top: none;
          }
        }
      }
      & .table-quotation__col {
        padding-bottom: 0;

        strong {
          font-size: 24px;
          white-space: nowrap;
          line-height: 1.2em;
        }
      }
    }

    &--value,
    &--cover-value,
    &--covers,
    &--button {
      .table-quotation__col:not(:first-child) {
        @media only screen and (max-width: 1210px) {
          div[size="4+"] &,
          div[size="4"] &,
          div[size="3"] & {
            box-shadow: inherit;
          }
        }

        @media only screen and (max-width: 1080px) {
          div[size="2"] & {
            box-shadow: inherit;
          }
        }
      }
    }

    &--best-seller,
    &--border,
    &--value,
    &--cover-value,
    &--covers,
    &--button,
    &--partner,
    &--planName,
    &--medicalBenefits {
      @media only screen and (max-width: 1080px) {
        div[size="2"] & {
          .table-quotation__col:first-child {
            margin-left: 0;
          }
        }
      }

      @media only screen and (max-width: 1210px) {
        div[size="4+"] &,
        div[size="4"] &,
        div[size="3"] & {
          .table-quotation__col:first-child {
            display: none;
          }

          .table-quotation__col:nth-child(2) {
            margin-left: 0;
          }
        }
      }
    }

    &--value,
    &--cover-value,
    &--covers,
    &--button,
    &--partner,
    &--medicalBenefits {
      .table-quotation__col + .table-quotation__col {
        background-color: $white;
      }
    }

    &--covers {
      text-align: left;
      display: none;

      .table-quotation__col {
        padding-top: 0;
        padding-bottom: 0;
      }

      @media only screen and (max-width: 1210px) {
        div[size="4+"] &,
        div[size="4"] &,
        div[size="3"] & {
          display: flex;

          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-bottom: none;
            border-top: none;
          }
        }
      }

      @media only screen and (max-width: 1080px) {
        div[size="2"] & {
          display: flex;

          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-bottom: none;
            border-top: none;
          }
        }
      }
    }

    &--button {
      font-family: $oscine-font-family;
      font-size: 20px;
      font-weight: bold;
      line-height: 1.2em;
      box-shadow: 0 20px 30px -10px rgba(0, 0, 0, 0.08);
      position: sticky;
      top: 195px;
      background-color: #f0f4f9;
      z-index: 1;

      @media only screen and (max-width: 1080px) {
        div[size="2"] & {
          position: relative;
          top: initial;
          z-index: initial;
          box-shadow: initial;

          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-top: none;
          }

          & .table-quotation__col {
            border-bottom-right-radius: 12px;
            border-bottom-left-radius: 12px;
          }
        }
      }

      @media only screen and (max-width: 1210px) {
        div[size="4+"] &,
        div[size="4"] &,
        div[size="3"] & {
          position: relative;
          top: initial;
          z-index: initial;
          box-shadow: initial;

          & .table-quotation__col:not(.table-quotation__col--best-seller) {
            border: 1px solid rgba(189, 194, 198, 0.4);
            border-top: none;
          }

          & .table-quotation__col {
            border-bottom-right-radius: 12px;
            border-bottom-left-radius: 12px;
          }
        }
      }

      @media only screen and (min-width: 1211px) {
        div[size="4"] &,
        div[size="4+"] &,
        div[size="3"] & {
          & .table-quotation__col:first-child {
            height: 58px;
            position: relative;
            top: 30px;
            align-items: center;
            background-color: $color-manatee;
            padding: 16px 24px;
            display: flex;
            font-size: 20px;
            font-weight: bold;
            font-family: $oscine-font-family;
            color: $white;
            border-top-left-radius: 12px;
            box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.08);
          }
        }
      }

      @media only screen and (min-width: 1081px) {
        div[size="2"] & {
          & .table-quotation__col:first-child {
            width: 176px;
            height: 58px;
            position: relative;
            top: 30px;
            align-items: center;
            background-color: $color-manatee;
            padding: 16px 24px;
            display: flex;
            font-size: 20px;
            font-weight: bold;
            font-family: $oscine-font-family;
            color: $white;
            border-top-left-radius: 12px;
            box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
          }
        }
      }

      & .table-quotation__col--best-seller {
        border-bottom: 2px solid;
      }
    }

    &--item {
      @media only screen and (max-width: 1210px) {
        div[size="4+"] &,
        div[size="4"] &,
        div[size="3"] & {
          display: none;
        }
      }
      @media only screen and (max-width: 1080px) {
        div[size="2"] & {
          display: none;
        }
      }

      @media only screen and (min-width: 1000px) {
        background-color: $white;

        .table-quotation__container:not(.table-quotation__container--listCoversCustom)
          &:nth-child(odd),
        .table-quotation__container--listCoversCustom &:nth-child(even) {
          background-color: #f1f4f8;
        }
      }

      .table-quotation__col:first-child {
        font-family: $rubik-font-family;
        color: $color-tundora;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.57;
        border-right: 1px solid rgba(189, 194, 198, 0.3);
        border-left: solid 1px rgba(189, 194, 198, 0.3);

        div[size="2"] & {
          width: 176px;
        }
      }

      .table-quotation__col:last-child {
        border-right: solid 1px rgba(189, 194, 198, 0.3);
      }

      .table-quotation__col:not(:first-child) {
        align-items: center;
        display: flex;
        justify-content: center;
        color: $color-scorpion;
        font-size: 16px;
        font-family: $rubik-font-family;
      }
    }

    &--partner {
      .table-quotation__col {
        &:not(.table-quotation__col--best-seller) {
          @media only screen and (max-width: 1080px) {
            div[size="2"] & {
              border: 1px solid rgba(189, 194, 198, 0.3);
              border-top: none;
              border-bottom: none;
            }
          }

          @media only screen and (max-width: 1210px) {
            div[size="4+"] &,
            div[size="4"] &,
            div[size="3"] & {
              border: 1px solid rgba(189, 194, 198, 0.3);
              border-top: none;
              border-bottom: none;
            }
          }
        }
      }

      .table-quotation__col__partner {
        display: block;
        margin: 0 auto;
        max-width: 200px;
        text-align: left;

        &:not(:last-child) {
          margin-bottom: 24px;
        }

        &__iconCheck {
          background: url("~@/assets/quotation-check.svg") no-repeat center;
          height: 24px;
          left: 0;
          position: absolute;
          top: calc(50% - 12px);
          width: 24px;
        }

        &__partnerLogoLivelo {
          background: url("https://ciclic.imgix.net/logo/livelo.webp?auto=format,compress?auto=format,compress") no-repeat left;
          background-size: cover;
          height: 48px;
          left: 10px;
          position: absolute;
          top: calc(50% - 20px);
          width: 48px;
        }

        &__text {
          color: $color-scorpion;
          font-family: $oscine-font-family;
          font-size: 16px;
          position: relative;
        }
      }
    }
  }

  &__col {
    padding: 24px 10px;
    width: 100%;
    max-width: 368px;

    @media only screen and (max-width: 1210px) {
      div[size="4+"] &,
      div[size="4"] &,
      div[size="3"] & {
        margin: 0 12px;
        min-width: 272px;

        &:last-child {
          margin: 0;
        }
      }
    }

    @media only screen and (max-width: 1080px) {
      div[size="2"] & {
        margin: 0 12px;
        min-width: 272px;

        &:last-child {
          margin: 0;
        }
      }
    }

    &:first-child {
      width: 100%;
      max-width: 175px;
      text-align: left;
    }

    & + & {
      border-left: 1px solid rgba(189, 194, 198, 0.3);

      &:nth-child(2) {
        @media screen and (min-width: 1081px) {
          border-left: none;
        }
      }

      &--best-seller {
        border-right: 2px solid;
        border-left: 2px solid;
        border-color: $color-purple-heart;
      }
    }

    &__partner {
      &--partnerLivelo {
        .table-quotation__col__partner__text {
          display: inline-block;
          padding-left: 70px;
        }
      }
      &--partnerDotz {
        .table-quotation__col__partner__text {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }
        img {
          max-width: 100px;
          margin-bottom: 8px;
        }
      }
    }
  }

  &__button {
    border: 1px solid $color-purple-heart;
    border-radius: 18px;
    background-color: transparent;
    color: $color-purple-heart;
    cursor: pointer;
    display: block;
    font-size: 14px;
    font-weight: bold;
    line-height: 36px;
    margin: 0 auto;
    max-width: 224px;
    padding: 0 6px;
    text-transform: uppercase;
    width: 100%;

    @media screen and (min-width: 1211px) {
      div[size="3"] &,
      div[size="2"] & {
        max-width: 272px;
      }
    }

    .table-quotation__col--best-seller & {
      background-color: $color-purple-heart;
      color: $white;
    }
  }

  &__cover-list {
    display: none;

    @media screen and (min-width: 426px) {
      display: flex;
    }

    &:first-child {
      margin-top: 16px;
    }
  }

  &__cover-link {
    width: 100%;
    display: inline-block;
    cursor: pointer;
    text-decoration: underline;
    padding: 16px 0 24px;
    text-align: center;
  }

  &__cover-label {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 156px;
    padding-right: 5px;
  }

  &__cover-value {
    display: block;
    font-weight: bold;
    font-family: $oscine-font-family;
  }
}

.plan-values {
  color: $color-tundora;
  font-family: $oscine-font-family;
  min-height: 182px;

  &__wrapped {
    display: inline-block;
  }

  &__old-amount,
  &__amount {
    font-size: 14px;
  }

  &__old-amount {
    margin-bottom: 4px;

    span {
      background-color: #77ff47;
      border-radius: 12px;
      font-size: 12px;
      margin-left: 16px;
      padding: 4px 12px;
      font-weight: bold;
    }

    & ~ .plan-values__lbl-amount {
      margin-top: 46px;
    }
  }

  &__amount {
    margin-bottom: 25px;

    &--no-installments {
      font-size: 40px;
      font-weight: 700;
      line-height: normal;
    }

    > span {
      font-weight: 400;
    }
  }

  &__lbl-installment,
  &__lbl-amount {
    font-size: 16px;
    font-weight: 400;
  }

  &__lbl-installment {
    text-align: left;
  }

  &__lbl-amount {
    font-weight: 700;
  }

  &__value-of-installments {
    font-size: 40px;
    font-weight: 700;
    line-height: normal;
  }

  &__lbl-no-swear {
    font-size: 12px;
    font-weight: 400;
    text-align: right;
    margin-bottom: 40px;
  }

  &__value-of-installments,
  &__amount--no-installments {
    color: $color-purple-heart;
  }

  &__value-of-installments,
  &__amount--no-installments {
    .table-quotation--partnerBB & {
      color: #0038a8;
    }
  }
}

.modal-covers {
  &__quotations {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    top: 0;

    dt {
      background-color: #f6fbfd;
      font-weight: normal;
      padding: 12px 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: $color-tundora;
      font-family: $rubik-font-family;
      font-size: 14px;
      font-weight: 500;
      padding: 24px;

      &:nth-child(even) {
        background-color: $white;
      }

      .coverLabel {
        @media screen and (max-width: 730px) {
          max-width: 128px;
        }
      }

      .coverValue {
        font-size: 16px;
        line-height: 1.25;
        color: $color-scorpion;
        font-weight: normal;
      }
    }
  }

  &__wrapper {
    width: 100%;
    max-width: 746px;
    background: $white;
    font-size: 12px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999999999;
    overflow: scroll;
    margin: 0 auto;
    border-radius: 8px;

    @media only screen and (max-width: 729px) {
      padding-bottom: 100px;
    }

    @media only screen and (min-width: 730px) {
      margin: 63px auto;
    }
  }

  &__title {
    background: $white url("~@/assets/close.svg") no-repeat center right 12px;
    cursor: pointer;
    font-family: $oscine-font-family;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    line-height: 52px;
    position: fixed;
    color: $color-tundora;
    width: 100%;
    max-width: 746px;
    border-radius: 8px;
    z-index: 99;

    @media screen and (max-width: 729px) {
      text-align: left;
      padding-left: 16px;
    }
  }

  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 70px;
    margin-bottom: 32px;

    @media screen and (max-width: 400px) {
      justify-content: flex-start;
      margin-left: 16px;
    }

    &__values {
      position: relative;
      text-align: center;

      @media screen and (max-width: 400px) {
        text-align: left;
      }
    }

    &__partner {
      position: relative;
      margin-left: 32px;

      @media only screen and (max-width: 400px) {
        display: none;
      }

      &--text {
        max-width: 114px;
        color: $color-scorpion;
        font-size: 14px;
        font-family: $rubik-font-family;
        font-weight: normal;
        line-height: 1.29;
        margin-left: 70px;
      }

      &__partnerLogoLivelo {
        background: url("~@/assets/partner/livelo/logo.svg") no-repeat left;
        height: 48px;
        left: 10px;
        position: absolute;
        top: 5px;
        width: 48px;
      }
    }
  }

  &__plan {
    font-family: $rubik-font-family;
    font-size: 16px;
    font-weight: bold;
    padding: 16px;
    color: $color-tundora;
    line-height: 1.38;
    font-weight: 500;
    border-top: 1px solid rgba(189, 194, 198, 0.2);
    box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.15);
    position: relative;
    z-index: 1;
  }
}
</style>
